// extracted by mini-css-extract-plugin
export default {"filtration":"Filtration_filtration__kJSdk","filteringButton":"Filtration_filteringButton__M+Ezs","active":"Filtration_active__swWGJ"};